import { getSidebarItem } from "../../../config/sidebarConfig";
import { CALENDAR } from "../../../routes";
import { circlesQuery, usersQuery } from "../../../services/queries";
import { viewQuery } from "../scopedQuery";
import { accessibleSubcircles, canAccessMainCircle } from "../../circles/circleAccess";
import { canOpenSidebarItem } from "../../navigation/sidebarAccess";
import type { AnswerContext } from "../catalogue/types";
import { EVERYONE } from "./recipients";
import type { TaskContext } from "./taskConversation";

/**
 * What a task needs to know about the Organization, for this Team member:
 * Everyone (if they may send to Everyone), their Circles, Users if they can open Users,
 * and whether they're on the Calendar.
 */
export async function loadTaskContext(
  { user, token, queryClient, pathname }: AnswerContext,
  today: Date = new Date()
): Promise<TaskContext> {
  const circles = await queryClient.fetchQuery(viewQuery(user, circlesQuery(user?.schoolId, token)));
  const canPickUsers = canOpenSidebarItem(getSidebarItem("users"), user);
  const users = canPickUsers ? await queryClient.fetchQuery(viewQuery(user, usersQuery(user?.schoolId, token))) : [];
  return {
    everyoneAndCircles: [
      ...(canAccessMainCircle(user) ? [{ kind: "everyone" as const, name: EVERYONE }] : []),
      ...accessibleSubcircles(circles, user).map((c) => ({ kind: "circle" as const, id: c.circleId, name: c.name })),
    ],
    users: users.map((u) => ({ kind: "user" as const, id: u.id, name: u.name })),
    organizationName: user?.schoolName,
    today,
    onCalendar: pathname === CALENDAR,
  };
}
